// Which chain a task belongs to, for its chip tint. Colour says WHICH CHAIN;
// the chip's text says which task, so the palette never grows with the task
// list. Read from the task's build-flow group (Tasks tab, "Group"), with the
// bundle's fixed table as the fallback for old grid IDs.
export type Chain = "chassis" | "cameras" | "fronts" | "usbc" | "encap" | "final" | "backs" | "brains" | "display" | "float" | "other";

const BY_GROUP: Record<string, Chain> = {
  chassis: "chassis",
  "camera module": "cameras",
  "front cover": "fronts",
  "usb-c": "usbc",
  "final assembly": "final",
  brain: "brains",
  "back cover": "backs",
  "display assembly": "display"
};

// Plan.html's CHAIN table, for tasks that come without a group.
const BY_CODE: Record<string, Chain> = {
  D1: "chassis", D2: "chassis", D3: "chassis", "D2/D3": "chassis", D5: "chassis", D6: "chassis", A2: "chassis",
  U1: "cameras", U2: "cameras", U5: "cameras", U6: "cameras", "U4+U25": "cameras",
  D7: "fronts", D12: "fronts", U12: "fronts", U13: "fronts", U17: "fronts", U14: "display",
  A1: "usbc", U11: "usbc", U18: "encap", A3: "final", D9: "backs", D10: "brains"
};

export function chainOf(task: string | null | undefined, group?: string | null): Chain {
  if (!task) return "float";
  // Encapsulation sits in the Chassis group but has its own tint on the board.
  if (task === "U18") return "encap";
  if (group && BY_GROUP[group.toLowerCase()]) return BY_GROUP[group.toLowerCase()];
  return BY_CODE[task] ?? "other";
}

export const CHAIN_LABEL: Record<Chain, string> = {
  chassis: "Chassis", cameras: "Camera module", fronts: "Front cover", usbc: "USB-C", encap: "Encapsulation",
  final: "Final assembly", backs: "Back cover", brains: "Brain", display: "Display assembly", float: "Float", other: "Other"
};
